const muiPropNames = [ "sx" ]

export const exProps = (...propsNames: string[]) => {
  
  return {
    shouldForwardProp: (prop: string) => !propsNames.includes(prop) && !muiPropNames.includes(prop)
  }
}